import * as cnt from './constants';

export const getSettings = () => ({ type: cnt.GET_SETTINGS });
export const saveSettings = payload => ({ type: cnt.SAVE_SETTINGS, payload });



// WEBPACK FOOTER //
// ./src/app/components/settings/__store__/actions.js